const topics = [
  { id: 1, name: '咒术回战', heat: '98.6万', trend: 'up', tag: '热议' },
  { id: 2, name: '海贼王', heat: '87.3万', trend: 'stable', tag: '经典' },
  { id: 3, name: '电锯人', heat: '76.8万', trend: 'up', tag: '新番' },
  { id: 4, name: '间谍过家家', heat: '65.4万', trend: 'up', tag: '人气' },
  { id: 5, name: '坂本日常', heat: '58.2万', trend: 'up', tag: '黑马' },
  { id: 6, name: '葬送的芙莉莲', heat: '52.1万', trend: 'stable', tag: '好评' },
  { id: 7, name: '怪兽8号', heat: '47.5万', trend: 'up', tag: '热门' },
  { id: 8, name: '胆大党', heat: '43.9万', trend: 'up', tag: '新番' },
  { id: 9, name: '蓝色监狱', heat: '39.2万', trend: 'stable', tag: '运动' },
  { id: 10, name: '我推的孩子', heat: '35.7万', trend: 'down', tag: '完结' },
  { id: 11, name: '琉璃龙龙', heat: '31.4万', trend: 'up', tag: '新作' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            社区热度
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            话题热榜
          </h2>
          <p className="text-foreground-500 text-sm mt-2">当前漫友圈讨论最热烈的日漫话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => (
            <div
              key={topic.id}
              className={`group flex items-center gap-3 px-4 py-3 rounded-xl border cursor-pointer transition-all ${
                idx < 3
                  ? 'bg-accent-50 border-accent-200 hover:bg-accent-100'
                  : 'bg-background-50 border-background-200/70 hover:border-background-300'
              }`}
            >
              <span className={`text-xs font-bold w-5 text-center ${
                idx < 3 ? 'text-accent-600' : 'text-foreground-400'
              }`}>
                {idx + 1}
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{topic.name}</span>
                  <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap ${
                    topic.tag === '热议' || topic.tag === '黑马' ? 'bg-primary-100 text-primary-700' :
                    topic.tag === '新番' || topic.tag === '新作' ? 'bg-accent-100 text-accent-700' :
                    topic.tag === '热门' || topic.tag === '人气' ? 'bg-secondary-100 text-secondary-700' :
                    'bg-background-200 text-foreground-500'
                  }`}>
                    {topic.tag}
                  </span>
                </div>
                <div className="flex items-center gap-1 mt-0.5">
                  <i className={`text-[10px] ${
                    topic.trend === 'up' ? 'ri-arrow-up-line text-primary-500' :
                    topic.trend === 'down' ? 'ri-arrow-down-line text-foreground-400' :
                    'ri-subtract-line text-foreground-400'
                  }`}></i>
                  <span className="text-xs text-foreground-400">{topic.heat} 热度</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}